import { useXState } from '@/composition/useXState'
import { AppState } from '@/state/appState'
import { PersoplanState } from '@/state/persoplanState'

export const appState = useXState(AppState)
export const persoplanState = useXState(PersoplanState)
